import { getValue } from "firebase/remote-config";
import { getFirebaseRemoteConfig } from "../../libs/firebase";
import UserMixins from "../../mixins/userMixins";

const isValidJSON = (data) => {
    try {
        return JSON.parse(data);
    } catch (error) {
        return false;
    }
};

export const ACTIVE_FEATURES = {
    SELLING_TICKET: "SELLING_TICKET",
};

export const getFireBaseFeatureValue = async (feature, user = null) => {
    if (feature === "" || feature === undefined || feature === null) {
        return false;
    }

    const remoteConfig = await getFirebaseRemoteConfig();
    const featureFlagValue = getValue(remoteConfig, feature);
    const jsonData = isValidJSON(featureFlagValue.asString());

    if (jsonData) {
        if (jsonData.enabled === true) {
            return true;
        }
        if (!!jsonData.emails && jsonData.emails.length > 0) {
            if (user === null) {
                return jsonData.emails.includes(await UserMixins.methods.getUserEmail());
            }
            return jsonData.emails.includes(user.email);
        }
        return jsonData === true;
    }
    return false;
};
